import React from 'react';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import { useTheme, alpha, lighten } from '@mui/material/styles';

// Hero background image.  Adjust the import path to match your project
// structure.  You can use any high‑quality image that represents
// logistics or international commerce.
import heroImage from '../assets/hero.jpg';

/**
 * Hero section introducing the company.  Displays a prominent
 * headline, a secondary line featuring the company name and a short
 * description plus a call‑to‑action button.  The background image
 * includes a dark overlay to ensure text readability.
 */
const Hero = () => {
  const theme = useTheme();
  return (
    <Box
      id="inicio"
      sx={{
        position: 'relative',
        minHeight: { xs: '75vh', md: '90vh' },
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: theme.palette.common.white,
        textAlign: 'center',
        overflow: 'hidden',
      }}
    >
      {/* Background image */}
      <Box
        sx={{
          position: 'absolute',
          inset: 0,
          backgroundImage: `url(${heroImage})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          zIndex: -2,
        }}
      />
      {/* Dark overlay for contrast */}
      <Box
        sx={{
          position: 'absolute',
          inset: 0,
          backgroundColor: alpha(theme.palette.primary.main, 0.5),
          zIndex: -1,
        }}
      />
      <Container>
        <Typography
          variant="h2"
          component="h1"
          sx={{
            fontWeight: 700,
            mb: 2,
            lineHeight: 1.2,
          }}
        >
          Soluciones Logísticas Internacionales
        </Typography>
        <Typography
          variant="h3"
          component="h2"
          color="secondary.main"
          sx={{
            fontWeight: 700,
            mb: 3,
          }}
        >
          ACOPIASERWA
        </Typography>
        <Typography
          variant="subtitle1"
          sx={{
            mb: 4,
            maxWidth: 600,
            mx: 'auto',
            color: alpha(theme.palette.common.white, 0.9),
          }}
        >
          Tu socio confiable en comercio internacional y gestión aduanera
        </Typography>
        <Button
          variant="contained"
      
          href="#contacto"
                sx={{
            bgcolor: alpha('#E7EBF0', 0.85),
            color: 'primary.main',
            px: 6,
            py: 1.5,
            borderRadius: 12,
            '&:hover': {
              bgcolor: alpha(lighten('#E7EBF0', 0.05), 0.85),
            },
          }}
        >
          Contáctanos
        </Button>
      </Container>
    </Box>
  );
};

export default Hero;